app.ui.registerUi('modal', function(app) {
    var helpers = app.helpers.funcs;

    var imgSrc;
    var imgHasLoaded = false;
    var initd = false;

	return {

	    // Additional classes that can be applied to the modal-wrap div to affect
	    // the modal's appearance
        additionalModalClasses: [],

        // ===================================================================
        // Module bootstrapping
        // ===================================================================

		implementationExists: function() {
			return jQuery.fn.modal ? true : false;
        },

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function ($scope) {
            if (initd) return;
            initd = true;
		    var scope = this;
		    var $modal = this.getMainModalElem();
            var $modalBody = this.getMainModalBodyElem();
		    $modal.on('shown.bs.modal', function () {
		        if ($modalBody.hasClass('awaiting-ui-init')) {
		            app.ui.initAll($modalBody);
		            $modalBody.removeClass('awaiting-ui-init');
		        }
		    });
		    $modal.on('hidden.bs.modal', function () {
		        scope.clearAllProperties();
		    });

            app.globalEventRegistry.addListener('resize', app.helpers.funcs.throttler(function () {
                scope.setModalImageDims();
            }, 100));
        },

        // ===================================================================
        // Module data
        // ===================================================================

        addModalClass: function (className, clearExistingCustomClasses) {
            clearExistingCustomClasses = typeof clearExistingCustomClasses !== 'undefined' ? !!clearExistingCustomClasses : false;
            if (clearExistingCustomClasses) {
                this.clearAdditionalModalClasses();
            }
		    this.additionalModalClasses.push(className);
        },

		applyAdditionalModalClasses: function () {
		    var $modal = this.getMainModalElem();
            var $modalWrap = this.getMainModalWrapElem();
		    this.additionalModalClasses.forEach(function (className) {
		        $modalWrap.addClass(className);
		    });
        },

        // ===================================================================
        // Getting DOM nodes
        // ===================================================================

		getMainModalElem: function () {
		    return $('#main-modal');
        },

        getMainModalWrapElem: function () {
            return this.getMainModalElem().closest('.modal-wrap');
        },

		getMainModalDialogElem: function() {
		    var $modalElem = this.getMainModalElem();
		    return $modalElem.find('.modal-dialog');
        },

		getMainModalTitleElem: function() {
		    var $modalElem = this.getMainModalElem();
		    return $modalElem.find('.main-modal-title');
        },

		getMainModalCloseElem: function () {
		    var $modalElem = this.getMainModalElem();
		    return $modalElem.find('.main-modal-close-text');
        },

		getMainModalSubTitleElem: function () {
		    var $modalElem = this.getMainModalElem();
		    return $modalElem.find('.main-modal-sub-title');
        },

		getMainModalBodyElem: function() {
		    var $modalElem = this.getMainModalElem();
		    return $modalElem.find('.main-modal-body');
        },

        // ===================================================================
        // Setting modal content
        // ===================================================================

        setTitle: function (text, setScreenReaderTitle) {
            var setScreenReaderTitle = typeof setScreenReaderTitle !== 'undefined' ? setScreenReaderTitle : true;
            var $modalTitleElem = this.getMainModalTitleElem();
            $modalTitleElem.text(text);
            if (setScreenReaderTitle) this.setScreenReaderTitle(text);
        },

        setSubTitle: function (text) {
            var $modalSubTitleElem = this.getMainModalSubTitleElem();
            $modalSubTitleElem.text(text);
            $modalSubTitleElem.removeClass('hidden');
            $modalSubTitleElem.removeAttr('aria-hidden');
        },

        setBody: function (text) {
            var $modal = this.getMainModalElem();
            $modal.removeClass('image-modal');
            var $modalBodyElem = this.getMainModalBodyElem();
            $modalBodyElem.text(text);
            this.flagBodyAsHavingUninitialisedUi();
        },

        setBodyHtml: function (html) {
            var $modal = this.getMainModalElem();
            $modal.removeClass('image-modal');
            var $modalBodyElem = this.getMainModalBodyElem();
            $modalBodyElem.html(html);
            this.flagBodyAsHavingUninitialisedUi();
        },

        setBodyImage: function (imgSrcInput) {

            imgHasLoaded = false;
            imgSrc = imgSrcInput;

            var scope = this;
            var $modal = this.getMainModalElem();
            var $modalBodyElem = this.getMainModalBodyElem();
            $modal.addClass('image-modal');
            var html = '<img class="full-modal-image" src="' + imgSrc + '" />';
            $modalBodyElem.html(html);
            this.setModalImageDims();
        },

        setScreenReaderTitle: function (text) {
            var $mainModalElem = this.getMainModalElem();
            $mainModalElem.attr('aria-label', text);
        },

        setCloseButtonText: function (text) {
            var $modalCloseElem = this.getMainModalCloseElem();
            $modalCloseElem.html(text);
        },

        // ===================================================================
        // Setting modal properties
        // ===================================================================

        setDataAttribute: function (k, v) {
            var $modalWrap = this.getMainModalWrapElem();
            $modalWrap.attr('data-' + k, v);
        },

        setIdAttribute: function (id) {
            var $modalWrap = this.getMainModalWrapElem();
            $modalWrap.attr('id', id);
        },

        setSize: function (size) {
            if (!$.inArray(size, ['sm', 'md', 'lg'])) {
                throw size + ' is not a valid modal size.';
            }
            var $modal = this.getMainModalElem();
            $modal.removeClass('modal-size-sm')
                .removeClass('modal-size-md')
                .removeClass('modal-size-lg')
                .addClass('modal-size-' + size);
        },

        setCenterVertical: function (align) {
            var $modal = this.getMainModalElem();
            $modal.removeClass('vertically-aligned');
            if (align) {
                $modal.addClass('vertically-aligned');
            }
        },

        // ===================================================================
        // Clearing modal content
        // ===================================================================

        clearTitle: function () {
            this.setTitle('');
        },

        clearSubTitle: function () {
            this.setSubTitle('');
        },

        clearTitles: function () {
            this.clearTitle();
            this.clearSubTitle();
        },

        clearScreenReaderTitle: function () {
            var $mainModalElem = this.getMainModalElem();
            $mainModalElem.attr('aria-label', '');
        },

        // ===================================================================
        // Clearing modal properties
        // ===================================================================

        clearAllProperties: function () {
            this.clearAdditionalModalClasses();
            this.clearDataAttributes();
            this.clearIdAttribute();
        },

        clearAdditionalModalClasses: function () {
            this.additionalModalClasses = [];
            var $modalWrap = this.getMainModalWrapElem();
            $modalWrap.removeClass();
            $modalWrap.attr('class', '');
            $modalWrap.addClass('modal-wrap');
        },

        clearDataAttributes: function () {
            var $modalWrap = this.getMainModalWrapElem();
            var attrs = $modalWrap.get(0).attributes;
            $.each(attrs, function (k, attr) {
                var attrName = attr ? attr.name : false;
                if (!attrName) return;
                if (attrName.substring(0, 5) == 'data-') {
                    $modalWrap.removeAttr(attrName);
                }
            });
        },

        clearIdAttribute: function () {
            var $modalWrap = this.getMainModalWrapElem();
            $modalWrap.removeAttr('id');
        },

        // ===================================================================
        // Modal control
        // ===================================================================

		show: function () {
		    this.applyAdditionalModalClasses();
            var $modal = this.getMainModalElem();
            var $modalWrap = this.getMainModalWrapElem();
            $modalWrap.removeAttr('aria-hidden');
		    $modal.modal('show');
        },

		hide: function () {
            var $modal = this.getMainModalElem();
            var $modalWrap = this.getMainModalWrapElem();
		    $modal.modal('hide');
            $modalWrap.attr('aria-hidden', 'true');
        },

        // ===================================================================
        // Helpers
        // ===================================================================

        // Adds a class to the modal body div, that causes all the UI widgets
        // (the scripts in ~\JDA\Dyson.Jda.web\Resources\app\assets\js\app\ui\...)
        // to be initialised on the modal area the next time that the modal is shown.
	    // We do this, as the modal animates in, and we only want to
	    // initialise / refresh the UI plugins once it has finished "showing"
        // and is completely "shown".
		flagBodyAsHavingUninitialisedUi: function () {
		    var $modalBodyElem = this.getMainModalBodyElem();
		    $modalBodyElem.addClass('awaiting-ui-init');
        },

        calculateAspectRatioFit: function(srcWidth, srcHeight, maxWidth, maxHeight) {
            var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
            return { width: srcWidth * ratio, height: srcHeight * ratio };
        },

        setModalImageDims: function () {

            if (!imgSrc) {
                return;
            }

            var scope = this;
            var $modal = scope.getMainModalElem();

            var windowHeight = parseInt($(window).height());
            var windowWidth = parseInt($(window).width());
            var blueSpacing = 15;
            var whiteSpacing = 15;
            var headerHeight = 50;

            var image = new Image();
            image.src = imgSrc;

            function respond(img) {
                var imageHeight = img.height;
                var imageWidth = img.width;
                var targetHeight = windowHeight - (blueSpacing * 2) - (whiteSpacing * 2) - headerHeight - 25;
                var targetWidth = windowWidth - (blueSpacing * 2) - (whiteSpacing * 2);
                var data = scope.calculateAspectRatioFit(imageWidth, imageHeight, targetWidth, targetHeight);
                $modal.find('.full-modal-image').css({
                    width: parseInt(data.width) + 'px',
                    height: parseInt(data.height) + 'px'
                });
                imgHasLoaded = true;
            };

            image.onload = function () {
                respond(this);
            };

            if (imgHasLoaded) respond(imgSrc);
        }
	};
});
